module.exports = __webpack_public_path__ + "static/media/gallery-11.18ae3f14.jpeg";